const zhipu = {
    toolsImg: require("@/assets/icon/zhipu.png"),
    toolsTitle: "智谱AI",
    toolsTag: "开源基座大模型",
    toolsDes: "智谱AI是一家源自清华大学计算机系技术成果的高科技公司，由张鹏作为CEO领军，自2019年成立以来，一直致力于推动人工智能技术的边界，特别是在认知智能领域。公司的核心愿景是实现让机器具备类似人类的思考方式",


    toolsChild: [
        {
            toolsChildId: 0,
            toolsTitle: "GLM-4系列",
            cardList: [
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "GLM-4-9B",
                    cardDes: "GLM-4-9B-Base",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/glm-4-9b"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "GLM-4-9B-Chat",
                    cardDes: "GLM-4-9B-Chat 微调模型",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/glm-4-9b-chat"
                },

                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "GLM-4-9B-Chat-1M",
                    cardDes: "GLM-4-9B-Chat 长上下文（1M context）系列",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/glm-4-9b-chat-1m"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "GLM-4V-9B",
                    cardDes: "GLM-4V-9B 是一个多模态语言模型，具备视觉理解能力",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/glm-4v-9b"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "LongWriter-GLM4-9B",
                    cardDes: "LongWriter-glm4-9b 是基于 glm-4-9b 训练的，能够一次性生成 10,000+ 词的文章",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/LongWriter-glm4-9b"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "LongCite-GLM4-9B",
                    cardDes: "LongCite-glm4-9b 是基于 glm-4-9b 训练的，能够针对长文本问答生成精细化的引用。该模型支持最大上下文窗口为 128K 个令牌。",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/LongCite-glm4-9b"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "GLM-4-Voice（论文）",
                    cardDes: "本文介绍了GLM-4-Voice，这是一个智能且类似人类的端到端语音聊天机器人。该模型支持中英文，能够实时进行语音对话，并根据用户指令调整情感、语调、语速和方言等语音细微差别。GLM-4-Voice采用超低比特率（175bps）的单码本语音分词器，帧率为12.5Hz，通过在自动语音识别（ASR）模型中引入向量量化瓶颈来实现。为了高效地将文本知识转移到语音模态，研究人员合成了从现有文本预训练语料库中提取的语音-文本交织数据。该模型从预训练的文本语言模型GLM-4-9B开始继续预训练，结合无监督语音数据、交织的语音-文本数据和监督的语音-文本数据，总规模达到1万亿个标记，在语音语言建模和口语问答任务中取得了最先进的性能。通过在高质量的对话语音数据上微调，该模型在对话能力和语音质量方面均优于现有的基线模型。",
                    cardLink: "https://modelscope.cn/papers/76638"
                },

            ]
        },
        {
            toolsChildId: 1,
            toolsTitle: "CogView 生图系列",
            cardList: [
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogView2",
                    cardDes: "CogView2系列",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/CogView2"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogView3-Plus-3B",
                    cardDes: "该模型是 CogView3 的 DiT 版本图像生成模型，支持从 512 到 2048 范围内的图像生成。",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/CogView3-Plus-3B"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogView4-6B",
                    cardDes: "CogView4系列",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/CogView4-6B"
                },
            ]
        },
        {
            toolsChildId: 2,
            toolsTitle: "CogAgent系列",
            cardList: [
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogAgent",
                    cardDes: "CogAgent-9B-20241220 模型基于 GLM-4V-9B 双语开源VLM基座模型。通过数据的采集与优化、多阶段训练与策略改进等方法，CogAgent-9B-20241220 在GUI感知、推理预测准确性、动作空间完善性、任务的普适和泛化性上得到了大幅提升，能够接受中英文双语的屏幕截图和语言交互。此版CogAgent模型已被应用于智谱AI的 GLM-PC产品 。我们希望这版模型的发布能够帮助到学术研究者们和开发者们，一起推进基于视觉语言模型的 GUI agent 的研究和应用。",
                    cardLink: "https://github.com/THUDM/CogAgent"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogAgent-9B-2024122（魔搭社区）",
                    cardDes: "CogAgent-9B-20241220 模型基于 GLM-4V-9B 双语开源VLM基座模型。通过数据的采集与优化、多阶段训练与策略改进等方法，CogAgent-9B-20241220 在GUI感知、推理预测准确性、动作空间完善性、任务的普适和泛化性上得到了大幅提升，能够接受中英文双语的屏幕截图和语言交互。此版CogAgent模型已被应用于智谱AI的 GLM-PC产品 。我们希望这版模型的发布能够帮助到学术研究者们和开发者们，一起推进基于视觉语言模型的 GUI agent 的研究和应用。",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/cogagent-9b-20241220"
                },

            ]
        },
        {
            toolsChildId: 3,
            toolsTitle: "CogVideo多模态文图生成视频系列",
            cardList: [
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogVideo",
                    cardDes: "CogVideoX是 清影 同源的开源版本视频生成模型。",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/CogVideo/files"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogVideoX-2B",
                    cardDes: "入门级模型，兼顾兼容性。运行，二次开发成本低",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/CogVideoX-2b"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogVideoX-5B",
                    cardDes: "视频生成质量更高，视觉效果更好的更大尺寸模型。",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/CogVideoX-5b"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogVideoX-5B-I2V",
                    cardDes: "CogVideoX-5B 图生视频版本。",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/CogVideoX-5b-I2V"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogVideoX1.5-5B",
                    cardDes: "CogVideoX1.5-5B 支持视频分辨率 1360 * 768",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/CogVideoX1.5-5B"
                },
                {
                    cardImg: require("@/assets/icon/zhipu.png"),
                    cardTitle: "CogVideoX1.5-5B-I2V",
                    cardDes: "CogVideoX1.5-5B-I2V 支持视频分辨率Min(W, H) = 768\n" +
                        "768 ≤ Max(W, H) ≤ 1360\n" +
                        "Max(W, H) % 16 = 0",
                    cardLink: "https://modelscope.cn/models/ZhipuAI/CogVideoX1.5-5B-I2V"
                },
            ]
        },

    ],
};
export default zhipu;